export default __webpack_public_path__ + "static/media/bonskewer.a3502feb.png";